import { render, staticRenderFns } from "./embedsrc.vue?vue&type=template&id=08db1e1c"
import script from "./embedsrc.vue?vue&type=script&lang=js"
export * from "./embedsrc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports